import { destroy as destroyRF } from 'redux-form'
import { destroy as destroySFM, prevFetch } from 'loankeeper-common/helpers/SimpleFetchManager'

import { destroy as destroyLKG } from '../shared/LKGrid'
import { RF_NAME, LK_GRID_NAME, ORDERS_FETCHER_NAME } from './constants'
import { destroyAccEntrySearch } from 'src/store/accEntry'
import { accEntrySearchMain } from 'src/store/accEntry'

export const closeOrderGrid = () => destroyLKG(LK_GRID_NAME)
export const closeSearchBar = () => destroyRF(RF_NAME)
// export const deleteOrders = () => destroySFM(ORDERS_FETCHER_NAME)
export const deleteOrders = () => destroyAccEntrySearch()
export const destroy = () => [closeOrderGrid(), closeSearchBar(), deleteOrders()]
// export const searchOrdersAgain = () => prevFetch({ instanceName: ORDERS_FETCHER_NAME })
export const searchOrdersAgain = () => accEntrySearchMain({ searchAgain: true })
